import { writable } from "svelte/store";
import Maze from "./maze";
const mazeStored = localStorage.getItem("maze");
const mazeData = mazeStored
    ? new Maze(JSON.parse(mazeStored))
    : Maze.basicMaze(30, 20);
export const maze = writable(mazeData);
maze.subscribe((value) => localStorage.setItem("maze", JSON.stringify(value.grid)));
const codeStored = localStorage.getItem("code");
const codeData = codeStored && codeStored != '""'
    ? JSON.parse(codeStored)
    : `return ({north, south, west, east, hasStone1, hasStone2, seeStone1, seeStone2, uniqueNW, uniqueNE, uniqueSW, uniqueSE}) => {
    // Available actions: north, south, west, east, place1, place2, pickup1, pickup2
    if (!north) {
        return "north";
    } else {
      if (hasStone1) {
        return "place1";
      } else if (hasStone2) {
        return "place2";
      } else if (!west) {
        return "west";
      } else if (!south) {
          return "south";
      }
    }
};`;
export const code = writable(codeData);
code.subscribe((value) => localStorage.setItem("code", JSON.stringify(value)));
const speedStored = localStorage.getItem("speed");
const speedData = speedStored ? JSON.parse(speedStored) : 500;
export const speed = writable(speedData);
speed.subscribe((value) => localStorage.setItem("speed", JSON.stringify(value)));
